import React from "react";

function VideoPlayer() {
  const runTestTrainVideo = { 
    id: 4, 
    title: "Run Test Train", 
    src: "path-to-your-test-train-video.mp4" 
  };

  return (
    <div>
      {/* Header Section */}
      <div className="bg-blue-50 p-6 rounded-lg mb-6">
        <h2 className="text-lg font-bold text-blue-800 mb-2">Video Player</h2>
        <p className="text-xs text-gray-600">
          Access instructional videos to assist with operations and troubleshooting. 
          Use the Run Test Train button below to start playback.
        </p>
      </div>

      {/* Video Player Section */}
      <div className="bg-gray-100 p-6 rounded-lg">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Playback</h3>

        <div className="mb-6">
          <button
            className="bg-blue-500 hover:bg-blue-600 text-white font-medium px-6 py-2 rounded-lg shadow-md transition text-xs"
            onClick={() => document.getElementById("video-player").src = runTestTrainVideo.src}
          >
            Play
          </button>
        </div>

        <div className="aspect-w-16 aspect-h-9 mb-4">
          <video
            id="video-player"
            className="w-full rounded-lg shadow-lg"
            controls
          >
            <source src={runTestTrainVideo.src} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <p className="text-xs text-gray-600">
          Use the controls above to play, pause, or adjust playback speed.
        </p>
      </div>
    </div>
  );
}

export default VideoPlayer;